import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as ProfileCreators } from "model/profileModal"
import { Creators as ExposureCreators } from "modules/analyze-historical-exposure/model"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { getDetails, getSelected, getSelectedValue } from "./selectors"
import { getDailyDetailsFormatter, getDetailsCurrencyScale } from "./selectors/scale"
import { getFiltersVisible } from "modules/analyze-header/selectors"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    ...state.modules.analyzeExposureDetails,
    details: getDetails(state, props),
    selected: getSelected(state, props),
    selectedValue: getSelectedValue(state, props),
    currencyScale: getDetailsCurrencyScale(state, props),
    dailyDetailsFormatter: getDailyDetailsFormatter(state, props),
    filtersVisible: getFiltersVisible(state, props),
  }),
  actions: {
    ...Creators,
    openSecurityProfile: ProfileCreators.openSecurityProfile,
    openFactorProfile: ProfileCreators.openFactorProfile,
    toggleLitmusView: ExposureCreators.toggleLitmusView,
    toggleShowNotHeld: PortfolioRootCreators.toggleShowNotHeld,
  },
})
